// extracted by mini-css-extract-plugin
export default {"panel":"Consulta_panel__r6U+f","subHeader":"Consulta_subHeader__vQGpy"};